module.exports = __webpack_public_path__ + "static/assets/7695b6f141042be8657724e077c1412b.png";